import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import MarketingStationLayout from 'app/shared-components/MarketingStationLayout';
import { useTopHeader } from 'app/hooks';
import FuseSuspense from '@/@fuse/core/FuseSuspense';

export default function CampaignListLayout(): JSX.Element {
  useTopHeader('Campaigns');

  return (
    <MarketingStationLayout>
      <Box className="grow bg-white flex flex-col overflow-y-auto rounded-8">
        <FuseSuspense>
          <Outlet />
        </FuseSuspense>
      </Box>
    </MarketingStationLayout>
  );
}
